import { render, staticRenderFns } from "./SuggestionTable.vue?vue&type=template&id=1a010fa4&scoped=true"
import script from "./SuggestionTable.vue?vue&type=script&lang=js"
export * from "./SuggestionTable.vue?vue&type=script&lang=js"
import style0 from "./SuggestionTable.vue?vue&type=style&index=0&id=1a010fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a010fa4",
  null
  
)

export default component.exports